
import { styleSheet } from "@matchlighter/common_library/lib/StyleSheet";
import { View } from "@instructure/ui-view";
import _styleSheetSrc from './Footer.module.scss';

const styles = styleSheet(_styleSheetSrc);

export const Footer: React.SFC = ({ children }) => {
    return <div className={styles('footer-wrapper')}>
        <View
            as="div"
            margin="0"
            padding="small"
            background="primary"
            borderWidth="small none none none"
        >
            {children}
        </View>
    </div>
}
